import React from 'react'
import styles from './MemberCard.module.scss'

const MemberCard = (props: any) => {
  const content = (
    <div className={styles['card']} style={{ maxWidth: props.maxWidth }}>
      <div className={styles['profile-image']}>
        <img src={props.path} alt={props.name} />
      </div>

      <p className={styles['member-name']}>{props.name}</p>
      <p className={styles['member-role']}>{props.role}</p>
      {props.role2 && <p className={styles['member-role2']}>{props.role2}</p>}

      {props.linkedin && (
        <span className={styles['icon']}>
          <img src='linkedin.png' alt='LinkedIn' />
        </span>
      )}
    </div>
  )

  if (props.linkedin) {
    return (
      <a
        href={props.linkedin}
        target='_blank'
        rel='noopener noreferrer'
        className={styles['card-link']}
      >
        {content}
      </a>
    )
  }

  return <div className={styles['card-link']}>{content}</div>
}

export default MemberCard
